import JsLogger from "js-logger"

// Using js-logger: https://github.com/jonnyreeves/js-logger
// Usage:
//   this.$logger.info("Main was started", args)
//   Vue.$logger.info("Main was started", args)
//   Logger.info("Main was started", args)

function stringify(obj) {
  return JSON.stringify(obj, (k, v) => (k ? "" + v : v))
}

function handleGlobalErrors(logger) {
  window.onerror = function(msg, url, line, col, err) {
    const errStr = stringify(err || {})
    const relativeUrl = url ? url.replace(/^(?:\/\/|[^/]+)*\//, "") : ""
    const message = `Uncaught: ${msg}, ${relativeUrl}:${line}:${col} - ${errStr}`
    logger.error(message)
    return !process.env.NODE_ENV === "development"
  }
}

export const logger = {
  install(Vue, options) {
    JsLogger.useDefaults({
      defaultLevel: JsLogger.INFO,
      formatter(messages, context) {
        if (Vue.prototype.$ga) {
          const action = messages ? messages.shift() : "unknown-error"
          const label = new Date().toISOString() + " " + messages.join("|")
          // https://stackoverflow.com/questions/12280993/google-analytics-event-tracking-max-string-length
          Vue.prototype.$ga.event({
            eventCategory: context.level.name,
            eventAction: action,
            eventLabel: label.substr(0, 500),
            eventValue: context.level.value
          })
        }
      },
      ...options
    })
    handleGlobalErrors(JsLogger)
    Vue.prototype.$logger = JsLogger
    Vue.$logger = JsLogger
  }
}
